import menu from './menu';
import title from './title';
import label from './label';
import permission from './permission';
import phrase from './phrase.json';
import statuses from './statuses.json';
import error from './error.json';
import flow from './flow.json';

export default {
  menu,
  title,
  label,
  permission,
  phrase,
  statuses,
  error,
  flow
};
